G.BoardCandy = G.BoardCandy || {};

G.BoardCandy.BoxStatus = function(candy) {
  this.wrapperImg = null;
  this.fakeBaseType = null;

  G.BoardCandy.CandyStatus.call(this, {});
};

G.BoardCandy.BoxStatus.prototype = Object.create(G.BoardCandy.CandyStatus.prototype);

G.BoardCandy.BoxStatus.prototype.init = function(candy, config, optColor) {
  G.BoardCandy.CandyStatus.prototype.init.call(this, candy, config);

  if (optColor === "r" && this.postRandomPhase) {
    optColor = null;
  }

  if (!optColor) {
    var maxTypeNumber = candy.board ? candy.board.lvl.nrOfTypes : 4;
    this.boxColor = game.rnd.between(1, maxTypeNumber).toString();
    if (!this.postRandomPhase) {
      this.boxColor = "r";
    }
  } else {
    this.boxColor = optColor;
  }

  this.wrapperImg = G.makeImage(0, 0, "gem_box_"+this.boxColor, 0.5, candy);
};

G.BoardCandy.BoxStatus.prototype.setMatchToken = function(color) {
  this.boxColor = color;
  this.wrapperImg.changeTexture("gem_box_"+this.boxColor);
};

G.BoardCandy.BoxStatus.prototype.onMatch = function() {
  this.signals.onRemove.dispatch();
  this.remove();
  return false;
};

G.BoardCandy.BoxStatus.prototype.remove = function() {
  G.sfx.brick_break.play();
  G.sb("onCollectableRemove").dispatch('bx',this.candy);
  G.sb("onCollectableRemove").dispatch('bx:'+this.boxColor,this.candy);

  if (!this.postRandomPhase) {
    this.wrapperImg.destroy();
  } else {
    game.add.tween(this.wrapperImg)
      .to({
        y: this.wrapperImg.y - 50,
        alpha: 0
      }, 1000, Phaser.Easing.Cubic.Out,true)
      .onComplete.add(function() {
        this.wrapperImg.destroy();
      },this)
  }
};

G.BoardCandy.BoxStatus.prototype.changeMatchToken = function(token) {
  // treat random box as transparent
  if (this.boxColor === "r") {
    return token;
  } else {
    return this.boxColor;
  }
};

G.BoardCandy.BoxStatus.prototype.changeForEditor = function() {
  console.log("changeForEditor");
  var options = ["r", "1", "2", "3", "4", "5", "6"];
  var newColor = options[options.indexOf(this.boxColor)+1];
  if (newColor) {
    this.boxColor = newColor
    this.wrapperImg.changeTexture("gem_box_"+this.boxColor);
  } else {
    this.signals.onRemove.dispatch();
    this.remove();
  }
};

G.BoardCandy.BoxStatus.prototype.passMatchable = function() {
  return true;
};

G.BoardCandy.BoxStatus.prototype.onHit = function() {
  return false;
};

G.BoardCandy.BoxStatus.prototype.export = function() {
  return this.editorSymbol + "|" + this.boxColor;
};